<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_404')}}</div>
    <div slot="body">
      <a-alert class="mb-2" :message="$t('scope.text_405')" banner />
      <a-form :form="form.fc">
        <a-form-item :label="$t('scope.text_406')" v-bind="formItemLayout">
          <a-input v-decorator="decorator.account" :placeholder="$t('username.placeholder')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_410')" v-bind="formItemLayout">
          <a-input-password v-decorator="decorator.password" :placeholder="$t('scope.text_411')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_324')" v-bind="formItemLayout">
          <a-input-group>
            <a-row :gutter="8">
              <a-col :span="18">
                <a-input v-decorator="decorator.captcha" :placeholder="$t('scope.text_409')" />
              </a-col>
              <a-col :span="6">
                <a-button :disabled="enableSendSmsCode" @click="getWebSmsCode" style="width: 100%">{{ enableSendSmsCode ? $t('scope.text_325', [count]) : $t('scope.text_326') }}</a-button>
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{$t('scope.text_412')}}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ForgetPasswordDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      count: 60,
      timer: null,
      form: {
        fc: this.$form.createForm(this),
      },
      decorator: {
        account: [
          'account',
          { rules: [{ required: true, message: this.$t('scope.text_408') }] },
        ],
        captcha: [
          'captcha',
          { rules: [{ required: true, message: this.$t('scope.text_337') }] },
        ],
        password: [
          'password',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_411') },
              { validator: this.checkPassword },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      userId: '',
      step: 1,
      captcha: '',
    }
  },
  watch: {
    startCountDown (val) {
      if (val) {
        this.clearTimer()
        this.timer = setInterval(() => {
          if (this.count !== 0) {
            this.count--
          } else {
            this.enableSendSmsCode = false
            this.startCountDown = false
          }
        }, 1000)
      }
    },
  },
  async created () {
    this.loading = true
    try {
      this.fetchCaptcha()
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    getWebSmsCode () {
      const account = this.form.fc.getFieldValue('account')
      if (!account) {
        this.$message.warn(this.$t('scope.text_414'))
        return
      }
      this.createDialog('WebSmsCodeDialog', {
        account,
        resource: 'resetcode',
        success: (responesData) => {
          this.userId = responesData.id
          this.enableSendSmsCode = true
          this.startCountDown = true
        },
      })
    },
    checkComPassword (rule, value, callback) {
      const password = this.form.fc.getFieldValue('password')
      if (password !== value) {
        callback(new Error(this.$t('scope.text_342')))
      }
      callback()
    },
    doResetPassword (data) {
      return this.$http.post('/v2/register/reset-password', data)
    },
    async handleConfirm () {
      let value = {}
      try {
        value = await this.form.fc.validateFields()
        if (!this.userId) {
          this.$message.warning(this.$t('scope.text_959'))
          return
        }
      } catch (error) {
        return
      }
      // send reset request
      this.loading = true
      try {
        const params = {
          password: value.password,
          random_code: value.captcha,
          id: this.userId,
        }
        await this.doResetPassword(params)
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('scope.text_415'))
      } catch (error) {
        this.loading = false
      }
    },
    checkPassword (rule, value, callback) {
      const passwordRegExp = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/
      if (!passwordRegExp.test(value)) {
        callback(new Error(this.$t('scope.text_411')))
      }
      callback()
    },
  },
}
</script>

<style lang="less" scoped>
.captcha-img {
  height: 28px;
  width: 98px;
}
</style>
